export default class CtaReadMore {
  constructor() {
    if ((this.readMoreBtns = document.querySelectorAll('.js-readmore'))) {
      this.cardItems = document.querySelectorAll('.js-card-item');
      this._registerClicks();
    }
  }

  _registerClicks() {
    for (let i = 0, l = this.readMoreBtns.length; i < l; i++) {
      this.readMoreBtns[i].addEventListener('click', (e) => {
        e.stopPropagation();

        window.location.href = '#' + this.readMoreBtns[i].dataset.anchor;

        this.readMoreBtns[i].classList.toggle('cta-link--opened');
        this.readMoreBtns[i].nextElementSibling.classList.toggle(
          'card-item-extratext--opened'
        );

        const currentCardItem = this.readMoreBtns[i].closest('.js-card-item');

        this.cardItems.forEach((cardItem) => {
          if (cardItem != currentCardItem) {
            cardItem.classList.remove('card-item--full-width');

            const button = cardItem.querySelector('.js-readmore');

            if (button) {
              button.classList.remove('cta-link--opened');
            }

            const extraText = cardItem.querySelector('.js-card-item-extratext');

            if (extraText) {
              extraText.classList.remove('card-item-extratext--opened');
            }

            const openImageBtn = cardItem.querySelector('.js-open-image-popup');

            if (openImageBtn) {
              openImageBtn.classList.remove('btn-expand-image--show');
            }
          }
        });

        currentCardItem.classList.toggle('card-item--full-width');

        const openImageBtn = currentCardItem.querySelector(
          '.js-open-image-popup'
        );

        if (openImageBtn) {
          openImageBtn.classList.toggle('btn-expand-image--show');
        }
      });
    }
  }
}
